import { createApp, routerLink, routerView } from '@digitalbranch/app'

import {
  uiScaffold,
  uiTopAppBarMedium,
  uiTopAppBarSmall,
  uiIcon,
  uiIconButton,
  uiRipple,
  uiOutlinedButton,
  uiNavigationDrawer,
  uiNavigationDrawerButton,
  uiPage,
  uiGrid,
  uiDivider,
  uiHeading,
  uiParagraph,
  SCAFFOLD_SERVICE_TOKEN,
  ScaffoldService,
  ViewportService,
  VIEWPORT_SERVICE_TOKEN,
  uiNavigationRailButton,
  uiTemplate,
  uiNavigationRail,
  uiCard,
  uiCardContent,
} from './ui'
import { router } from './routes'
import { main, pageHeader, syntaxHighlighting } from './components'

const icons = [
  'check',
  'check_box',
  'code',
  'content_copy',
  'dark_mode',
  'home_pin',
  'light_mode',
  'menu',
  'menu_open',
  'syringe',
  'tools_power_drill',
]

createApp({
  el: '#app',
  provide: {
    icons,
    [SCAFFOLD_SERVICE_TOKEN]: new ScaffoldService(),
    [VIEWPORT_SERVICE_TOKEN]: new ViewportService(),
  },
  components: {
    routerLink,
    routerView,
    main,
    scaffold: uiScaffold,
    uiTopAppBarMedium,
    uiTopAppBarSmall,
    uiIcon,
    uiIconButton,
    uiRipple,
    uiOutlinedButton,
    uiNavigationDrawer,
    uiNavigationDrawerButton,
    uiNavigationRail,
    uiNavigationRailButton,
    uiPage,
    uiGrid,
    uiDivider,
    uiHeading,
    uiParagraph,
    uiTemplate,
    uiCard,
    uiCardContent,
    syntaxHighlighting,
    pageHeader,
  },
  router,
})
